export default "__VITE_ASSET__LRe85Sw3__"